export default "__VITE_ASSET__2d662fbb__"